import { render, staticRenderFns } from "./InsightsInfoList.vue?vue&type=template&id=70df02ac&"
import script from "./InsightsInfoList.vue?vue&type=script&lang=js&"
export * from "./InsightsInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports